import { useEffect, useState } from 'react';
import useFetch from 'hooks/fetch';
import { getRecurringBuyPreview } from '../actions';
const useRecurringOrderPreview = ({ amount, assetId, buyConfig, nonTradingDayPreference, }) => {
    const [nextBuy, setNextBuy] = useState('');
    const [loading, setLoading] = useState(true);
    const [fetch] = useFetch();
    useEffect(() => {
        const fetchPreview = async () => {
            try {
                const response = await fetch(getRecurringBuyPreview({
                    amount,
                    assetId,
                    buyConfig,
                    nonTradingDayPreference,
                }));
                setNextBuy(response.nextBuy);
            }
            catch {
                //
            }
            finally {
                setLoading(false);
            }
        };
        fetchPreview();
    }, [amount, assetId, buyConfig, nonTradingDayPreference]);
    return [loading, nextBuy];
};
export default useRecurringOrderPreview;
